<template>
	<shark-loader v-if="faqsLoading"/>
	<div v-else-if="faqsLoading === false" class="section">
		<div class="container">
			<div class="title">Frequently Asked Questions</div>
			<div class="content is-medium" v-html="faqs[0].html" />
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
	name: 'FrequentlyAskedQuestionsHome',
	computed: {
		...mapState(["faqsLoading", "faqs"]),
	},
	created() {
		if (this.faqsLoading == null) {
			this.$store.dispatch("loadFaqs");
		}
	}
}
</script>

<style lang="scss" scoped>
.section {
	text-align: left;
	padding-top: 1.5rem;
}
.title {
	text-align: center;
}
</style>